/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Loading, Tile } from 'carbon-components-react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { getBranding } from '../../util/branding';
import WatsonIcon from '../icons/WatsonIcon';

import './InstancesLoading.scss';

const messages = defineMessages({
  welcome: {
    id: 'modules.ia.components.Instances.InstancesLoading.welcome',
    defaultMessage: 'Welcome to {productName}'
  },
  loadingInstances: {
    id: 'modules.ia.components.Instances.InstancesLoading.loadingInstances',
    defaultMessage: 'Loading instances...'
  }
});

const InstancesLoading: React.FC = () => {
  const { productName } = getBranding();
  return (
    <div className="InstancesLoading">
      <Tile className="InstancesLoading__tile">
        <div>
          <FormattedMessage
            tagName="h3"
            {...messages.welcome}
            values={{ productName }}
          />
          <WatsonIcon className="InstancesLoading__Robot" />
        </div>
        <div className="InstancesListloading__tile-footer">
          <span className="InstancesListloading__tile-footer-text">
            <FormattedMessage {...messages.loadingInstances} />
          </span>
          <Loading small withOverlay={false} />
        </div>
      </Tile>
    </div>
  );
};

export default InstancesLoading;
